"use client";

import { c as _c } from "react/compiler-runtime";
import { cn } from "@repo/ui/utils.ts";
import { NavigationProvider, useNavigationState } from "./navigation-provider";
import { SearchOverlay } from "@/components/search/search-overlay.component";
import { useAudience } from "@/components/common/audience";
import { useHideOnScroll } from "./use-hide-on-scroll";
import type { NavigationData } from "@/components/navigation/navigation.types";
interface NavbarShellProps {
  children: React.ReactNode;
  navigationData: NavigationData;
}
export function NavbarShell(t0) {
  const $ = _c(12);
  const {
    children,
    navigationData
  } = t0;
  const {
    activeTab
  } = useAudience();
  const isBusinesses = activeTab === "businesses";
  const t1 = isBusinesses && "dark";
  let t2;
  if ($[0] !== t1) {
    t2 = cn("[--navbar-height:112px] desktop-lg:[--navbar-height:145px]", t1);
    $[0] = t1;
    $[1] = t2;
  } else {
    t2 = $[1];
  }
  let t3;
  if ($[2] === Symbol.for("react.memo_cache_sentinel")) {
    t3 = <a href="#main-content" className="sr-only focus:not-sr-only focus:fixed focus:top-2 focus:left-2 focus:z-[100] focus:rounded focus:bg-surface-base-primary focus:px-4 focus:py-2 focus:text-text-primary focus:shadow-lg">Skip to main content</a>;
    $[2] = t3;
  } else {
    t3 = $[2];
  }
  let t4;
  if ($[3] !== children) {
    t4 = <NavbarHeader>{children}</NavbarHeader>;
    $[3] = children;
    $[4] = t4;
  } else {
    t4 = $[4];
  }
  let t5;
  if ($[5] === Symbol.for("react.memo_cache_sentinel")) {
    t5 = <div className="h-[var(--navbar-height,112px)]" />;
    $[5] = t5;
  } else {
    t5 = $[5];
  }
  let t6;
  if ($[6] !== t2 || $[7] !== t4) {
    t6 = <div className={t2}>{t3}{t4}{t5}</div>;
    $[6] = t2;
    $[7] = t4;
    $[8] = t6;
  } else {
    t6 = $[8];
  }
  let t7;
  if ($[9] !== navigationData || $[10] !== t6) {
    t7 = <NavigationProvider navigationData={navigationData}>{t6}</NavigationProvider>;
    $[9] = navigationData;
    $[10] = t6;
    $[11] = t7;
  } else {
    t7 = $[11];
  }
  return t7;
}
function NavbarHeader(t0) {
  const $ = _c(8);
  const {
    children
  } = t0;
  const {
    isMobileMenuOpen,
    isSearchOpen
  } = useNavigationState();
  const t1 = isMobileMenuOpen || isSearchOpen;
  let t2;
  if ($[0] !== t1) {
    t2 = {
      disabled: t1
    };
    $[0] = t1;
    $[1] = t2;
  } else {
    t2 = $[1];
  }
  const hidden = useHideOnScroll(t2);
  const t3 = hidden && "-translate-y-full";
  let t4;
  if ($[2] !== t3) {
    t4 = cn("fixed top-0 left-0 right-0 z-50 bg-surface-base-primary text-text-primary", "transition-transform duration-300 ease-in-out motion-reduce:transition-none", t3);
    $[2] = t3;
    $[3] = t4;
  } else {
    t4 = $[3];
  }
  let t5;
  if ($[4] === Symbol.for("react.memo_cache_sentinel")) {
    t5 = <SearchOverlay />;
    $[4] = t5;
  } else {
    t5 = $[4];
  }
  let t6;
  if ($[5] !== children || $[6] !== t4) {
    t6 = <header className={t4}>{children}{t5}</header>;
    $[5] = children;
    $[6] = t4;
    $[7] = t6;
  } else {
    t6 = $[7];
  }
  return t6;
}